module.exports = __webpack_public_path__ + "img/Andaluza-8-min.f57ef404.jpg";